import * as React from 'react'
import { useNotificationHook } from '@hyper/use-notification-hook'
import { useApiRequest } from '@components/hooks/use-api-request'
import { useAppDispatch } from '@store/index'
import { AssetCategory } from '@models/cms-asset'
import { removeAssetCategory } from '@store/actions/asset-actions'
import { CommonObjectConfirmAction } from '@components/common-objects-confirm-action'

interface Props {
  category: AssetCategory
}

export const CmsAssetCategoriesTableRowRemove = ({ category }: Props): JSX.Element => {
  const { addSuccessMessage } = useNotificationHook()
  const dispatch = useAppDispatch()

  const { isLoading, action: onAccept } = useApiRequest(
    React.useCallback(async () => {
      dispatch(removeAssetCategory(category))
      addSuccessMessage('Sukces', 'Kategoria została skasowana')
    }, [category]),
  )

  return (
    <CommonObjectConfirmAction isLoading={isLoading} handleAccept={onAccept}>
      <i className="uil-trash-alt cursor-pointer font-18 text-muted" title="Skasuj" />
    </CommonObjectConfirmAction>
  )
}
